import { Component, ViewChild, ElementRef } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 'tutorial-screen',
  templateUrl: './tutorial-screen.html',
  styleUrls: ['./tutorial-screen.scss'],
})

export class TutorialScreen {

  @ViewChild('slider') sliderEl: ElementRef;

  private slideCount: number = 5;

  private activeSlide: number = 0;

  showButtons: boolean = false;

  /**
   * 튜토리얼 활성화 여부
   */
  private activation: boolean = true;

  constructor(private $local: LocalStorageService) {
    // 튜토리얼 졸업 시 비활성화
    if ($local.getTutorial()) {
      this.activation = false;
      return;
    }
  }

  ngAfterViewInit() {
    if (this.sliderEl) {
      this.sliderInit();
    }
  }

  /**
   * Slider 초기화
   */
  sliderInit() {
    const sliderManager = new Hammer.Manager(this.sliderEl.nativeElement);
    sliderManager.add(new Hammer.Pan({ threshold: 0, pointers: 0 }));
    sliderManager.on('pan', (e) => {
      const percentage = 100 / this.slideCount * e.deltaX / window.innerWidth;
      const transformPercentage = percentage - 100 / this.slideCount * this.activeSlide;
      this.sliderEl.nativeElement.style.transform = 'translateX( ' + transformPercentage + '% )';
      if (!e.isFinal) {
        return;
      }
      percentage < 0 ? this.goToSlide(this.activeSlide + 1) :
        percentage > 0 ? this.goToSlide(this.activeSlide - 1) :
          this.goToSlide(this.activeSlide);
    });
  }

  /**
   * 슬라이드가 변경될때
   */
  goToSlide(number:number) {
    this.showButtons = number > 3;
    this.activeSlide = number < 0 ?
      0 : number > this.slideCount - 1 ?
        this.slideCount - 1 : number;

    const percentage = -(100 / this.slideCount) * this.activeSlide;
    this.sliderEl.nativeElement.style.transform = `translateX(${percentage}%)`;
  }

  /**
   * 튜토리얼 활성화 여부
   */
  isActive(): boolean {
    return this.activation;
  }

  /**
   * 튜토리얼 종료하고 더 이상 출력하지 않음
   */
  neverShowTutorial() {
    this.activation = false;
    this.$local.setTutorial();
  }

  /**
   * 튜토리얼 종료
   */
  closeTutorial() {
    this.activation = false;
  }
}
